"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockVideoTutorialsData = exports.mockVideoTutorialUrl = exports.mockVideoTutorialData = void 0;
var tags_1 = require("../interfaces/tags");
exports.mockVideoTutorialData = [
    [
        {
            uuid: 'd1e77277-6e62-4c61-9ff7-320ec8b13b85',
            displayName: 'rivka test',
            description: 'rivka test',
            duration: '00:02:05',
            updatedAt: '2023-11-06T16:03:06.000Z',
            imageUrl: 'https://content.devcodebashing.com/video-tutorials/d1e77277-6e62-4c61-9ff7-320ec8b13b85/image.svg',
            videoUrl: 'https://content.devcodebashing.com/video-tutorials/d1e77277-6e62-4c61-9ff7-320ec8b13b85/video.mp4',
            createdAt: '2023-11-06T16:03:06.000Z',
            status: 'completed',
            month: 'May',
            earnedPoints: 100,
            potentialPoints: 100,
        },
        {
            uuid: '939fd9cb-57d8-41b2-9c26-f0a42b4ad6a2',
            displayName: 'test',
            description: 'test',
            duration: '00:30:00',
            updatedAt: '2023-11-06T15:43:59.000Z',
            imageUrl: 'https://content.devcodebashing.com/video-tutorials/939fd9cb-57d8-41b2-9c26-f0a42b4ad6a2/image.png',
            videoUrl: 'https://content.devcodebashing.com/video-tutorials/939fd9cb-57d8-41b2-9c26-f0a42b4ad6a2/video.mp4',
            createdAt: '2023-11-06T15:43:59.000Z',
            status: 'not_started',
            month: 'January',
            earnedPoints: 0,
            potentialPoints: 100,
        },
        {
            uuid: '4915a0bf-95b5-4a7b-96b0-fc1b099c523c',
            displayName: 'arie test 1',
            description: 'arie test 1',
            duration: '02:02:02',
            updatedAt: '2023-11-02T07:18:17.000Z',
            imageUrl: 'https://content.devcodebashing.com/video-tutorials/4915a0bf-95b5-4a7b-96b0-fc1b099c523c/image.png',
            videoUrl: 'https://content.devcodebashing.com/video-tutorials/4915a0bf-95b5-4a7b-96b0-fc1b099c523c/video.mp4',
            createdAt: '2023-11-02T07:18:17.000Z',
            status: 'not_started',
            month: 'July',
            earnedPoints: 0,
            potentialPoints: 100,
        },
        {
            uuid: 'd8175c49-2131-40f4-a045-c24da9fdc9af',
            displayName: 'video tutorial name',
            description: 'description',
            duration: '00:03:16',
            updatedAt: '2023-08-16T08:03:25.000Z',
            imageUrl: 'https://content.devcodebashing.com/video-tutorials/d8175c49-2131-40f4-a045-c24da9fdc9af/image.svg',
            videoUrl: 'https://content.devcodebashing.com/video-tutorials/d8175c49-2131-40f4-a045-c24da9fdc9af/video.mp4',
            createdAt: '2023-08-16T08:03:25.000Z',
            status: 'not_started',
            earnedPoints: 0,
            potentialPoints: 100,
        },
        {
            uuid: 'b30839af-2c3d-4d78-b70c-1986926c491d',
            displayName: '8',
            description: '8',
            duration: '03:00:05',
            updatedAt: '2023-08-10T10:22:32.000Z',
            imageUrl: 'https://content.devcodebashing.com/video-tutorials/b30839af-2c3d-4d78-b70c-1986926c491d/image.svg',
            videoUrl: 'https://content.devcodebashing.com/video-tutorials/b30839af-2c3d-4d78-b70c-1986926c491d/video.mp4',
            createdAt: '2023-08-10T10:22:32.000Z',
            status: 'not_started',
            earnedPoints: 0,
            potentialPoints: 100,
        },
    ],
];
exports.mockVideoTutorialUrl = {
    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
    signedUrl: 'www.s3.com/images/file-name.svg',
    contentType: 'svg',
    contentUrl: 'www.images.codebashing.com/file-name.svg',
};
exports.mockVideoTutorialsData = {
    wiki: [
        {
            uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b2a',
            displayName: 'Video tutorial name 2',
            description: 'Video tutorial description 2',
            duration: '01:39:24',
            imageUrl: 'https://picsum.photos/200?random=2',
            videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b2a',
            updatedAt: new Date('2023-03-25T10:31:09.800Z'),
            status: 'not_started',
            earnedPoints: 0,
            potentialPoints: 100,
            tags: [
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
                    category: tags_1.TagCategories.VIDEO_TUTORIALS,
                    displayName: 'Wiki',
                    name: 'wiki',
                },
            ],
            createdAt: '2021-10-1T12:00:00.000Z',
        },
        {
            uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b3a',
            displayName: 'Video tutorial name 3',
            description: 'Video tutorial description 3',
            duration: '00:03:07',
            imageUrl: 'https://picsum.photos/200?random=3',
            videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b3a',
            updatedAt: new Date('2023-03-12T11:38:19.800Z'),
            status: 'not_started',
            earnedPoints: 0,
            potentialPoints: 100,
            tags: [
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
                    category: tags_1.TagCategories.VIDEO_TUTORIALS,
                    displayName: 'Wiki',
                    name: 'wiki',
                },
            ],
            createdAt: '2021-10-11T12:00:00.000Z',
        },
        {
            uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b4a',
            displayName: 'Video tutorial name 4',
            description: 'Video tutorial description 4',
            duration: '00:56:00',
            imageUrl: 'https://picsum.photos/200?random=4',
            videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b4a',
            updatedAt: new Date('2023-03-04T09:31:49.800Z'),
            status: 'completed',
            earnedPoints: 0,
            potentialPoints: 100,
            tags: [
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
                    category: tags_1.TagCategories.VIDEO_TUTORIALS,
                    displayName: 'Wiki',
                    name: 'wiki',
                },
            ],
            createdAt: '2021-10-11T12:00:00.000Z',
        },
    ],
    monthly: [
        {
            uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b5a',
            displayName: 'Video tutorial name 5',
            description: 'Video tutorial description 5',
            duration: '00:12:29',
            imageUrl: 'https://picsum.photos/200?random=5',
            videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b5a',
            updatedAt: new Date('2023-02-21T10:31:49.800Z'),
            status: 'started',
            earnedPoints: 0,
            potentialPoints: 100,
            month: 'February',
            tags: [
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1p',
                    category: tags_1.TagCategories.VIDEO_TUTORIALS,
                    displayName: 'Monthly',
                    name: 'monthly',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1b',
                    category: tags_1.TagCategories.MONTH,
                    displayName: 'January',
                    name: '01',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1c',
                    category: tags_1.TagCategories.YEAR,
                    displayName: '2023',
                    name: '2023',
                },
            ],
            createdAt: '2021-10-11T12:00:00.000Z',
        },
        {
            uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
            displayName: 'Video tutorial name 7',
            description: 'Video tutorial description 7',
            duration: '00:00:09',
            imageUrl: 'https://picsum.photos/200?random=7',
            videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
            updatedAt: new Date('2023-02-05T12:34:45.800Z'),
            status: 'not_started',
            earnedPoints: 0,
            month: 'March',
            tags: [
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1p',
                    category: tags_1.TagCategories.VIDEO_TUTORIALS,
                    displayName: 'Monthly',
                    name: 'monthly',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b3b',
                    category: tags_1.TagCategories.MONTH,
                    displayName: 'March',
                    name: '03',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1c',
                    category: tags_1.TagCategories.YEAR,
                    displayName: '2023',
                    name: '2023',
                },
            ],
            createdAt: '2021-10-15T12:00:00.000Z',
        },
        {
            uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
            displayName: 'Video tutorial name 8',
            description: 'Video tutorial description 8',
            duration: '10:00:09',
            imageUrl: 'https://picsum.photos/200?random=8',
            videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
            updatedAt: new Date('2023-02-05T12:34:45.800Z'),
            isCompleted: false,
            tags: [
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1p',
                    category: tags_1.TagCategories.VIDEO_TUTORIALS,
                    displayName: 'Monthly',
                    name: 'monthly',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b4b',
                    category: tags_1.TagCategories.MONTH,
                    displayName: 'April',
                    name: '04',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1c',
                    category: tags_1.TagCategories.YEAR,
                    displayName: '2023',
                    name: '2023',
                },
            ],
        },
        {
            uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
            displayName: 'Video tutorial name 9',
            description: 'Video tutorial description 9',
            duration: '00:12:00',
            imageUrl: 'https://picsum.photos/200?random=9',
            videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
            updatedAt: new Date('2023-02-05T12:34:45.800Z'),
            status: 'completed',
            earnedPoints: 100,
            potentialPoints: 100,
            tags: [
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1p',
                    category: tags_1.TagCategories.VIDEO_TUTORIALS,
                    displayName: 'Monthly',
                    name: 'monthly',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b4b',
                    category: tags_1.TagCategories.MONTH,
                    displayName: 'April',
                    name: '04',
                },
                {
                    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b2c',
                    category: tags_1.TagCategories.YEAR,
                    displayName: '2024',
                    name: '2024',
                },
            ],
        },
    ],
    currentMonth: {
        uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
        displayName: 'Video tutorial name 6',
        description: 'Video tutorial description 6',
        duration: '00:08:51',
        imageUrl: 'https://picsum.photos/200?random=6',
        videoUrl: 'https://content.devcodebashing/video-tutorials/8eaefbe2-bedb-4da4-96c1-68b52cf10b6a',
        updatedAt: new Date('2023-02-05T12:34:45.800Z'),
        isCompleted: false,
        earnedPoints: 0,
        potentialPoints: 100,
        tags: [
            {
                uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1p',
                category: tags_1.TagCategories.VIDEO_TUTORIALS,
                displayName: 'Monthly',
                name: 'monthly',
            },
            {
                uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b2b',
                category: tags_1.TagCategories.MONTH,
                displayName: 'February',
                name: '02',
            },
            {
                uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1c',
                category: tags_1.TagCategories.YEAR,
                displayName: '2023',
                name: '2023',
            },
        ],
        createdAt: '2021-10-11T12:00:00.000Z',
    },
};
